export function updateSearchQuery(query: string, params: Record<string, string | number | boolean>) {
  const search = new URLSearchParams(query);
  Object.entries(params).forEach(([key, value]) => {
    search.set(key, `${value}`);
  });

  return search.toString();
}
